import { createApi } from '@reduxjs/toolkit/dist/query/react/index';
import { ToastContent } from 'react-toastify';
import type { BulkVerb } from 'src/utils/bulkResults';

import { TAG_TYPES } from './config/apiTags';
import { baseQueryWithTokenExpirationCheck } from './config/query.config';

export const baseAPI = createApi({
  reducerPath: 'baseApi',
  baseQuery: baseQueryWithTokenExpirationCheck,
  tagTypes: [...TAG_TYPES],
  endpoints: () => ({}),
});

// Used to add custom toasts, see redux/middleware.ts:
export const apiToasts: {
  [endpointName: string]: {
    pending?: string | false | 0;

    /** Custom content for the success toast; `0`/`false` suppresses it. */
    fulfilled?: ToastContent | false | 0;

    error?: {
      default?: string | false | 0;
      [status: number]: string | false | 0;
    };

    /** Milliseconds before auto-dismiss; `false` keeps the toast until closed. */
    autoClose?: number | false;

    /**
     * Marks an endpoint returning per-item results. Its success toast is one
     * summary of what succeeded and what failed, and it shows a pending toast
     * only when `pending` is a message.
     */
    bulkResults?: { noun: string; verb: BulkVerb };
  };
} = {};

export function setToast(
  endpointName: string,
  toast: (typeof apiToasts)[string]
) {
  apiToasts[endpointName] = toast;
}
